<i18n>
{
	"en": {
		"confirmRemovalArea": "Are you sure you want to remove area: {areaName}?"
	},
	"no": {
		"confirmRemovalArea": "Er du sikker på at du vil fjerne området: {areaName}?"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:hasHeader="false"
		icon="cog"
		iconType="bp"
		width="480px"
		@ok="$emit('confirm')"
		@close="$emit('close')"
	>
		{{$t('confirmRemovalArea', {areaName: areaName})}}
	</t-dialog>
</template>

<script>
export default {
	name: 'ConfirmRemoveArea',
	props: {
		isShown: Boolean,
		item: Object
	},
	computed: {
		areaName() {
			return this.item? this.item.name : '';
		}
	}

};
</script>
